import {
  Box,
  Button,
  Dialog,
  DialogContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
  Typography,
  InputAdornment
} from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import { region } from "../../config/images";
import SearchIcon from "@mui/icons-material/Search";
import RegionTable from "./RegionTable";
import StateTable from "./StateTable";
import LocalGovernment from "./LocalGovernment";
import { addLocalGovernmentList, addRegionList, addStateList, getLocalGovernmentList, getRegionList, getStateDetails, getStateList } from "../../config/services";
import { toast } from "react-toastify";


const Region = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [regionpopup, setRegionPopup] = useState(false);
  const [statePopup, setStatePopup] = useState(false);
  const [localGovernmentPopup, setLocalGovernmentPopup] = useState(false);
  const [importExcel, setImportExcel] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [regionName, setRegionName] = useState();
  const [searchText, setSearchText] = useState();
  const [debounceSearchText, setDebouncedSearchText] = useState();
  const [regionData, setRegionData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [localGovernmentData, setLocalGovernmentData] = useState([]);
  const [regionCurrentPage, setRegionCurrentPage] = useState(1);
  const [regionTotalPages, setRegionTotalPages] = useState();
  const [regionCount, setRegionCount] = useState();

  const [stateCurrentPage, setStateCurrentPage] = useState(1);
  const [stateTotalPages, setStateTotalPages] = useState();
  const [stateCount, setStateCount] = useState();

  const [localGovCurrentPage, setLocalGovCurrentPage] = useState(1);
  const [localGovTotalPages, setLocalGovTotalPages] = useState();
  const [localGovCount, setLocalGovCount] = useState();
  const [perPage, setPerPage] = useState(10);

  const notify = (message) => {
    toast.error(message, {
      theme: "colored",
      position: toast.POSITION_TOP_RIGHT,
      toastClassName: "custom-toast",
    });
  };

  const notifySuccess = (message) => {
    toast.success(message, {
      theme: "colored",
      position: toast.POSITION_TOP_RIGHT,
      toastClassName: "custom-toast",
    });
  };

  const [selectedRegion, setSelectedRegion] = useState(""); // Store selected region for state
  const [selectedState, setSelectedState] = useState(""); // Store selected state for local government
  const [state, setState] = useState();
  const [category, setCategory] = useState();

  // 🔹 Flags to determine which data should be refreshed
  const [regionUpdated, setRegionUpdated] = useState(false);
  const [stateUpdated, setStateUpdated] = useState(false);
  const [localGovUpdated, setLocalGovUpdated] = useState(false);

  // 🔹 Loading
  const [regionLoading, setRegionLoading] = useState(false);
  const [stateLoading, setStateLoading] = useState(false);
  const [localGovLoading, setLocalGovLoading] = useState(false);
  const [stateBasedOnRegion, setStateBasedOnRegion] = useState([]);

  const fetchRegions = async () => {
    try {
      const searchParams = { search: debounceSearchText };
      const resp = await getRegionList(searchParams, regionCurrentPage, perPage);
      if (resp.data.results.success) {
        setRegionData(resp.data.results.payload);
        setRegionCount(resp.data.count);
      }

    } catch (error) {
      console.log(error);
      toast.error("Failed to fetch regions!");
    }
  };
  // 🔹 Fetch only states when updated
  const fetchStates = async () => {
    try {
      const searchParams = { search: debounceSearchText };
      const resp = await getStateList(searchParams, stateCurrentPage, perPage);
      if (resp.data.results.success) {
        setStateData(resp.data.results.payload);
        setStateCount(resp.data.count);
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to fetch states!");
    }
  };

  // 🔹 Fetch only local governments when updated
  const fetchLocalGovernments = async () => {
    try {
      const searchParams = { search: debounceSearchText };
      const resp = await getLocalGovernmentList(searchParams, localGovCurrentPage, perPage);
      if (resp.data.results.success) {
        setLocalGovernmentData(resp.data.results.payload);
        setLocalGovCount(resp.data.count);
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to fetch local governments!");
    }
  };

  useEffect(() => {
    if (activeTab === 0) {
      fetchRegions();
    } else if (activeTab === 1) {
      fetchStates();
    } else if (activeTab === 2) {
      fetchLocalGovernments();
    }
  }, [activeTab, debounceSearchText, regionCurrentPage, stateCurrentPage, localGovCurrentPage]);

  // 🔹 Fetch only updated data
  useEffect(() => {
    if (regionUpdated) {
      fetchRegions();
      setRegionUpdated(false); // Reset flag
    }
  }, [regionUpdated]);

  useEffect(() => {
    if (stateUpdated || regionUpdated) {
      fetchStates();
      setStateUpdated(false); // Reset flag
      setRegionUpdated(false) // Reset flag
    }
  }, [stateUpdated, regionUpdated]);

  useEffect(() => {
    if (localGovUpdated || stateUpdated || regionUpdated) {
      fetchLocalGovernments();
      setLocalGovUpdated(false); // Reset flag
      setStateUpdated(false); // Reset flag
      setRegionUpdated(false) // Reset flag
    }
  }, [localGovUpdated, stateUpdated, regionUpdated]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setPreview(URL.createObjectURL(file)); // Generate preview URL
    }
  };
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  const handleAddRegion = async (e) => {
    e.preventDefault();

    if (!regionName) {
      notify("Please select a Region name.");
      return;
    }

    const params = {
      region_name: regionName
    }
    try {
      setRegionLoading(true);
      const resp = await addRegionList(params);
      if (resp.data.success == true) {
        setRegionPopup(false);
        notifySuccess(resp.data.message);
        setRegionName("");  // Reset input field
        fetchRegions();
        setTimeout(() => {
          setRegionLoading(false);
        }, 2000);
      }

    } catch (error) {
      console.log(error);
      notify(error.response.data.message);
      setRegionPopup(false);
      setTimeout(() => {
        setRegionLoading(false);
      }, 2000);
    }
  }
  const handleAddState = async (e) => {
    e.preventDefault();
    if (!selectedRegion) {
      notify("Please select a Region.");
      return;
    }
    if (!state) {
      notify("Please enter a State name.");
      return;
    }
    const params = {
      region: selectedRegion,
      state_name: state
    }
    try {
      setStateLoading(true);
      const resp = await addStateList(params);
      if (resp.data.success == true) {
        notifySuccess(resp.data.message);
        setStatePopup(false);
        setState(""); // Reset input field
        setSelectedRegion(""); // Reset selected region
        fetchStates();
        setTimeout(() => {
          setStateLoading(false);
        }, 2000);
      }

    } catch (error) {
      console.log(error);
      notify(error.response.data.message);
      setStatePopup(false);
      setTimeout(() => {
        setStateLoading(false);
      }, 2000);
    }
  }
  const handleAddLocalGovernment = async (e) => {
    e.preventDefault();

    if (!selectedRegion) {
      notify("Please select a Region.");
      return;
    }

    if (!selectedState) {
      notify("Please select State.");
      return;
    }

    if (!category) {
      notify("Please enter a Local Government name.");
      return;
    }
    const params = {
      region: selectedRegion,
      state: selectedState,
      local_government_name: category,
    };

    try {
      setLocalGovLoading(true);
      const resp = await addLocalGovernmentList(params);
      if (resp.data.success === true) {
        setLocalGovernmentPopup(false);
        notifySuccess(resp.data.message);
        fetchLocalGovernments();
        setCategory(""); // Reset input field
        setSelectedState(""); // Reset selected state
        setSelectedRegion(""); // Reset selected region
        setTimeout(() => {
          setLocalGovLoading(false);
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      notify(error.response.data.message)
      setTimeout(() => {
        setLocalGovLoading(false);
      }, 2000);
    }
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText); // Update the debounced searchText
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler); // Cleanup the timeout
    };
  }, [searchText]); // Effect runs when searchText changes

  const getStateBasedOnRegion = async (regionId) => {
    try {
      const resp = await getStateDetails(regionId);
      if (resp.data.results.success == true) {
        setStateBasedOnRegion(resp.data.results.payload)
      }
    } catch (error) {
      console.log("error", error);
      notify(error.response.data.message);
    }
  };

  useEffect(() => {
    if (selectedRegion) {
      getStateBasedOnRegion(selectedRegion)
    }

  }, [selectedRegion]);


  
  return (
    <>
      <Box className="task-assign-box">
        <Box className="d-flex justify-content-between align-items-center" style={{flexWrap:"wrap"}}>
          <Box className="d-flex  gap-3 img-box" style={{ padding: "25px" }}>
            <img src={region.region} alt="" />
            <Typography variant="h6" gutterBottom>
              Region & Locality
            </Typography>
          </Box>
          <Box  className="assign-data-btn">
            <img
              src={region.deleteIcon}
              alt=""
              style={{ marginRight: "10px" }}
              className="delete-btn"
            />
            <button className="deactivate-btn" style={{ marginRight: "10px" }}>
              Demo File
            </button>
            <button
              className="deactivate-btn"
              style={{ marginRight: "10px" }}
              onClick={() => setImportExcel(true)}
            >
              Import Excel
            </button>
            {activeTab === 0 && (
              <button
                className="assign-task-btn"
                style={{ marginLeft: "0px" }}
                onClick={() => setRegionPopup(true)}
              >
                Add Region
              </button>
            )}
            {activeTab === 1 && (
              <button
                className="assign-task-btn"
                style={{ marginLeft: "0px" }}
                onClick={() => setStatePopup(true)}
              >
                Add State
              </button>
            )}
            {activeTab === 2 && (
              <button
                className="assign-task-btn"
                style={{ marginLeft: "0px" }}
                onClick={() => setLocalGovernmentPopup(true)}
              >
                Add Local Government
              </button>
            )}
          </Box>
        </Box>
        <Box sx={{ width: "max-content" }} className="pt-2">
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            className="custom-tabs data-tabs"
            TabIndicatorProps={{ style: { display: "none" } }}
          >
            <Tab label="Region" />
            <Tab label="State" />
            <Tab label="Local Government" />
          </Tabs>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #31A05F",
            borderRadius: "8px",
            overflow: "hidden",
            margin: "0px 20px",
            boxShadow: "0px 4px 10px rgba(151, 151, 151, 0.12)"
          }}
          className="mt-3"
        >
          <TextField
            placeholder="Search here"
            variant="outlined"
            size="small"
            sx={{
              flex: 1,
              "& .MuiOutlinedInput-root": {
                borderRadius: 0,
                paddingRight: "0px",
                "& fieldset": {
                  border: "none",
                },
              },
            }}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" sx={{
                  color: "#FFFFFF",
                  fontWeight: "400",
                  backgroundColor: "#31A05F",
                  height: "100%",
                  padding: "0px",
                  maxHeight: "unset",
                  padding: "0px 15px"

                }}>
                  <SearchIcon sx={{ color: "#FFFFFF", mr: 1 }} />
                  Search
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box>
          <div className="tab-content">
            {activeTab === 0 &&
              <RegionTable
                regionData={regionData}
                setRegionUpdated={setRegionUpdated}
                regionCurrentPage={regionCurrentPage}
                setRegionCurrentPage={setRegionCurrentPage}
                regionCount={regionCount}
                perPage={perPage}
              />}
            {activeTab === 1 &&
              <StateTable
                stateData={stateData}
                regionData={regionData}
                setStateUpdated={setStateUpdated}
                stateCurrentPage={stateCurrentPage}
                setStateCurrentPage={setStateCurrentPage}
                stateCount={stateCount}
                perPage={perPage}
              />}
            {activeTab === 2 &&
              <LocalGovernment
                localGovernmentData={localGovernmentData}
                stateData={stateData}
                regionData={regionData}
                setLocalGovUpdated={setLocalGovUpdated}
                localGovCurrentPage={localGovCurrentPage}
                setLocalGovCurrentPage={setLocalGovCurrentPage}
                localGovCount={localGovCount}
                perPage={perPage}
              />}
          </div>
        </Box>
        <Dialog
          open={regionpopup}
          // onClose={() => setRegionPopup(false)}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        // className="dialog-assign"
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                Add Region
              </h5>
            </div>
          </div>
          <DialogContent>
            <form noValidate autoComplete="off">
              <TextField
                fullWidth
                label="Enter Region"
                name="regionTitle"
                value={regionName}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  // Allow only letters and spaces, limit to 50 characters
                  if (/^[A-Za-z\s]*$/.test(inputValue) && inputValue.length <= 50) {
                    setRegionName(inputValue);
                  }
                }}
                inputProps={{ maxLength: 50 }}
                className="mb-3"
              />

              <div className="d-flex gap-3 mt-2">
                <button
                  className="cancel-button"
                  onClick={(e) => {
                    e.preventDefault();
                    setRegionPopup(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="assign-task-button"
                  disabled={regionLoading}
                  onClick={(e) => handleAddRegion(e)}
                >
                  {regionLoading ? <span className="spinner"></span> : "Add Region"}
                </button>
              </div>
            </form>
          </DialogContent>
        </Dialog>
        <Dialog
          open={statePopup}
          // onClose={() => setStatePopup(false)}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        // className="dialog-assign"
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                Add State
              </h5>
            </div>
          </div>
          <DialogContent>
            <form noValidate autoComplete="off">
              <FormControl fullWidth className="mb-3">
                <InputLabel>Select Region</InputLabel>
                <Select
                  label="Select Region"
                  name="region"
                  value={selectedRegion}
                  onChange={(e) => setSelectedRegion(e.target.value)}
                >
                  {regionData.map((item, index) => (
                    <MenuItem value={item.id}>{item.region_name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                fullWidth
                label="Enter State"
                name="taskTitle"
                value={state}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  // Allow only letters and spaces, limit to 50 characters
                  if (/^[A-Za-z\s]*$/.test(inputValue) && inputValue.length <= 50) {
                    setState(inputValue);
                  }
                }}
                inputProps={{ maxLength: 50 }}
                className="mb-3"
              />

              <div className="d-flex gap-3 mt-2">
                <button
                  className="cancel-button"
                  onClick={(e) => {
                    e.preventDefault();
                    setStatePopup(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="assign-task-button"
                  disabled={stateLoading}
                  onClick={(e) => handleAddState(e)}
                >
                 {stateLoading ? <span className="spinner"></span> : "Add State"}
                </button>
              </div>
            </form>
          </DialogContent>
        </Dialog>
        <Dialog
          open={localGovernmentPopup}
          // onClose={() => setLocalGovernmentPopup(false)}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        // className="dialog-assign"
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                Add Local Government
              </h5>
            </div>
          </div>
          <DialogContent>
            <form noValidate autoComplete="off">
              <FormControl fullWidth className="mb-3">
                <InputLabel>Select Region</InputLabel>
                <Select
                  label="Select Region"
                  name="region"
                  value={selectedRegion}
                  onChange={(e) => setSelectedRegion(e.target.value)}
                >
                  {regionData.map((item, index) => (
                    <MenuItem value={item.id}>{item.region_name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth className="mb-3">
                <InputLabel>Select State</InputLabel>
                <Select
                  label="Select State"
                  name="region"
                  value={selectedState}
                  onChange={(e) => setSelectedState(e.target.value)}
                >
                  {stateBasedOnRegion.map((item, index) => (
                    <MenuItem value={item.id}>{item.state_name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                fullWidth
                label="Enter Category"
                name="taskTitle"
                value={category}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  // Allow only letters and spaces, limit to 50 characters
                  if (/^[A-Za-z\s]*$/.test(inputValue) && inputValue.length <= 50) {
                    setCategory(inputValue);
                  }
                }}
                inputProps={{ maxLength: 50 }}
                className="mb-3"
              />

              <div className="d-flex gap-3 mt-2">
                <button
                  className="cancel-button"
                  onClick={(e) => {
                    e.preventDefault();
                    setLocalGovernmentPopup(false);
                  }}
                  style={{ fontSize: "14px" }}
                >
                  Cancel
                </button>
                <button
                  className="assign-task-button"
                  onClick={(e) => handleAddLocalGovernment(e)}
                  style={{ fontSize: "14px" }}
                  disabled={localGovLoading}
                >
               {localGovLoading ? <span className="spinner"></span> : "Add  Local Government"}
                </button>
              </div>
            </form>
          </DialogContent>
        </Dialog>
        <Dialog
          open={importExcel}
          // onClose={() => setImportExcel(false)}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        // className="dialog-assign"
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                Import Excel
              </h5>
            </div>
          </div>
          <DialogContent>
            <Box textAlign="center">
              <input
                type="file"
                accept="image/*"
                id="file-upload"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <label htmlFor="file-upload">
                <Box
                  sx={{
                    width: "390px",
                    height: "150px",
                    border: "2px dashed #3C4856",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    overflow: "hidden",
                    backgroundColor: "#fff",
                    boxShadow: "0px 4px 10px rgba(160, 160, 160, 0.16)"
                  }}
                >
                  {preview ? (
                    <img
                      src={preview}
                      alt="Preview"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <img src={region.browseImage} alt="" />
                  )}
                </Box>
              </label>
              <div className="d-flex gap-3 mt-4">
                <button
                  className="cancel-button"
                  onClick={(e) => {
                    e.preventDefault();
                    setImportExcel(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="assign-task-button"
                  onClick={() => setImportExcel(false)}
                >
                  Submit
                </button>
              </div>
            </Box>
          </DialogContent>
        </Dialog>
      </Box>
    </>
  );
};
export default Region;
